<template>
  <div class="exam-end-box">
    <StatusRedirect
      status="COMPLETED"
      @rewrite="(status) => checkApplicantStatus(status)"
    />
    <div v-if="applicantStatus === 'COMPLETED'">
      <p>これでコーディング試験の全工程が終了です。</p>
      <p>ありがとうございました。</p>
      <p>結果は後ほどご連絡いたしますので、しばらくお待ちください。</p>
    </div>
  </div>
</template>

<script>
import StatusRedirect from '@/main/frontend/components/StatusRedirect.vue';

export default {
  components: {
    StatusRedirect,
  },
  data() {
    return {
      applicantStatus: '',
    };
  },
  methods: {
    checkApplicantStatus(status) {
      this.applicantStatus = status;
    },
  },
};
</script>

<style>
.exam-end-box {
  left: 50%;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
</style>
